import { useEffect } from 'preact/hooks';

/** Where the browser's own menu still opens: text a player types, to paste or correct it. */
const TEXT_FIELDS = 'input, textarea, [contenteditable=""], [contenteditable="true"]';

/**
 * The right click is the game's (the world, the map, its panels): the browser's context menu never
 * takes it, except over text fields. One listener for every screen, so no surface forgets it.
 */
export function useGameContextMenu(): void {
  useEffect(() => {
    const suppress = (event: MouseEvent): void => {
      const target = event.target;
      if (target instanceof Element && target.closest(TEXT_FIELDS)) return;
      event.preventDefault();
    };
    document.addEventListener('contextmenu', suppress);
    return () => {
      document.removeEventListener('contextmenu', suppress);
    };
  }, []);
}
